import { Navigate } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth, db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import { useEffect, useState } from "react";

/**
 * @param {ReactNode} children - Component to protect
 * @param {string} allow - Role allowed ("admin" | "user")
 */
export default function ProtectedRoute({ children, allow }) {
  const [user, loading] = useAuthState(auth);
  const [role, setRole] = useState(null);
  const [checkingRole, setCheckingRole] = useState(true);

  useEffect(() => {
    const loadRole = async () => {
      if (!user) {
        setCheckingRole(false);
        return;
      }

      try {
        const snap = await getDoc(doc(db, "users", user.uid));
        if (snap.exists()) {
          setRole(snap.data().role);
        }
      } catch (err) {
        console.error("Role check failed", err);
      } finally {
        setCheckingRole(false);
      }
    };

    loadRole();
  }, [user]);

  /* ⏳ Loading state */
  if (loading || checkingRole) {
    return (
      <div className="h-screen flex items-center justify-center text-gray-600">
        Checking access…
      </div>
    );
  }

  /* 🔐 Not logged in */
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  /* ⛔ Role not allowed */
  if (allow && role !== allow) {
    return <Navigate to="/" replace />;
  }

  /* ✅ Access granted */
  return children;
}
